import { appInfoSelector } from '@common/redux/selectors/app';
import {
  createAppleTouchIcon,
  createManifest,
} from '@common/screens/ShareScreen/SetupShare';
import React, { Fragment, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Platform } from 'react-native';
import { useSelector } from 'react-redux';

function HelmetCustom({ screen }: any) {
  const appInfo = useSelector(appInfoSelector);

  if (!appInfo || !screen) return <Fragment></Fragment>;

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    async function setupManifest() {
      if (!appInfo) return;
      const data = appInfo;
      const manifestEl = document.querySelector("link[rel='manifest']");
      const appleTouchIconEl = document.querySelector(
        "link[rel='apple-touch-icon']"
      );

      const maniFestHref = createManifest(data?.appId, data?.name, data?.icon);
      const appleTouchIcon = createAppleTouchIcon(data?.icon);
      manifestEl?.setAttribute('href', await maniFestHref);
      appleTouchIconEl?.setAttribute('href', appleTouchIcon);
    }
    setupManifest();
  }, [appInfo]);

  return (
    <Helmet>
      <title>{`${appInfo?.name} | ${screen?.name}`}</title>
      <meta name="description" content={appInfo?.description} />
      <meta property="og:title" content={appInfo?.name ?? ''} />
      <meta property="og:description" content={appInfo?.description ?? ''} />
      <meta property="og:image" content={appInfo?.thumbnails?.[0] ?? ''} />
      {/* Google Tag Manager */}
      {appInfo.metadata?.gtm?.id && (
        <script>
          {`(function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${appInfo.metadata.gtm.id}');`}
        </script>
      )}

      {/* Google Analytics */}
      {appInfo.metadata?.ga4?.id && (
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${appInfo.metadata.ga4.id}`}
        ></script>
      )}
      {appInfo.metadata?.ga4?.id && (
        <script>
          {`window.dataLayer = window.dataLayer || [];
             function gtag(){dataLayer.push(arguments);}
             gtag('js', new Date());
             gtag('config', '${appInfo.metadata.ga4.id}');`}
        </script>
      )}

      {/* Facebook Pixel */}
      {appInfo.metadata?.fbPixel?.id && (
        <script>
          {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${appInfo.metadata.fbPixel.id}');
          fbq('track', 'PageView');`}
        </script>
      )}
    </Helmet>
  );
}

export default HelmetCustom;
